// removed by extract-text-webpack-plugin
module.exports = {"contract":"pages-PaymentProcess-PerchaseTerms-contract","tab":"pages-PaymentProcess-PerchaseTerms-tab","center":"pages-PaymentProcess-PerchaseTerms-center","title":"pages-PaymentProcess-PerchaseTerms-title","tips":"pages-PaymentProcess-PerchaseTerms-tips","content":"pages-PaymentProcess-PerchaseTerms-content","itemTitle":"pages-PaymentProcess-PerchaseTerms-itemTitle","b":"pages-PaymentProcess-PerchaseTerms-b","link":"pages-PaymentProcess-PerchaseTerms-link"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/PaymentProcess/PerchaseTerms/index.css
// module id = 1817
// module chunks = 0